import { promiseActionFactory } from "@teroneko/redux-saga-promise";

import { createActionTypes } from "utils/store";
import { IAdminInfo, IEditAdmin, IRegistrationAdmin } from "../../types/administration.types";
import { LoadListDataParams, LoadListDataResponse } from "../../hooks/useListData";

export const ADMINISTRATION_REDUCER = 'administration'

const ADMINISTRATION_ACTIONS = {
  CREATE_ADMIN: 'CREATE_ADMIN',
  LOAD_ADMINS: 'LOAD_ADMINS',
  EDIT_ADMIN: 'EDIT_ADMIN',
  DELETE_ADMIN: 'DELETE_ADMIN',
};

const actionTypes = createActionTypes(ADMINISTRATION_REDUCER, ADMINISTRATION_ACTIONS)

export const createAdminAction = promiseActionFactory<IAdminInfo>().create<Omit<IRegistrationAdmin, 'confirm'>>(actionTypes.CREATE_ADMIN)
export const loadAdminsAction = promiseActionFactory<LoadListDataResponse<IAdminInfo>>().create<LoadListDataParams>(actionTypes.LOAD_ADMINS)
export const editAdminAction = promiseActionFactory<IAdminInfo>().create<IEditAdmin>(actionTypes.EDIT_ADMIN)
export const deleteAdminAction = promiseActionFactory().create<IAdminInfo>(actionTypes.DELETE_ADMIN)